import React from 'react';
import { StaggerReveal } from '../ui';

function TrustIcon({ index }: { index: number }) {
  if (index === 0) return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" className="w-[22px] h-[22px]"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>;
  if (index === 1) return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" className="w-[22px] h-[22px]"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>;
  if (index === 2) return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" className="w-[22px] h-[22px]"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>;
  return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" className="w-[22px] h-[22px]"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>;
}

const trustCards = [
  { title: 'Be yourself', desc: "Your photos, age, and information should be genuine. Authentic profiles build real trust." },
  { title: 'Verified accounts', desc: "Users can verify their identity with an ID document. Verified profiles get a badge so you know they're real." },
  { title: 'Report violations', desc: 'Encounter inappropriate behaviour? Report it instantly. Our team takes immediate action.' },
  { title: 'Mutual connections only', desc: 'Both users must connect with each other before a conversation can begin.' },
];

export default function Trust() {
  return (
    <section className="bg-black py-16 lg:py-[100px] px-[5%]" id="rules">
      <p className="text-xs font-medium tracking-[2.5px] uppercase text-pink-300 mb-4 block">Trust &amp; Safety</p>
      <h2 className="text-[clamp(28px,4vw,44px)] font-bold tracking-[-1.2px] text-white mb-8 lg:mb-[60px]">A space built on respect.</h2>
      <StaggerReveal className="rounded-[16px] overflow-hidden grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-0.5">
        {trustCards.map((c, i) => (
          <div key={i} className="bg-[#141414] p-6 sm:p-9 hover:bg-[#1a1a1a] transition-colors duration-300">
            <div className="w-12 h-12 rounded-[14px] bg-[#1f1f1f] flex items-center justify-center mb-5 text-pink-300"><TrustIcon index={i} /></div>
            <h3 className="text-[17px] font-semibold mb-2.5 text-white">{c.title}</h3>
            <p className="text-[13px] text-white/45 leading-relaxed">{c.desc}</p>
          </div>
        ))}
      </StaggerReveal>
    </section>
  );
}
